import request from '@/utils/request'
/**
 * @apiName 获取审批任务列表
 * @apiUrl
 */
export function getApprovalTaskList(data = {}) {
  return request({
    // url: '/admin/v1/vehicle/approvalTask/getPage',
    url: '/admin/v1/approval/approvalTask/getPage',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 提交审核结果
 * @apiUrl
 */
export function approvalTaskSubmit(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/submit',
    // url: '/admin/v1/vehicle/approvalTask/submit',
    method: 'POST',
    data,
  })
}
